import { PropertyRoutes } from "./property.route";
import { post, get, put,deleted,patch } from "../index";

const PropertyServices = {
  createProperty: async (obj) => {
    let result = post(PropertyRoutes.createProperty, obj);
    return result;
  },
  getProperty: async (search,id,page,limit,minPrice,maxPrice,type,purpose,minArea="",maxArea="",dateFrom="",dateTo="",isAdminPanel="false") => {
    let result = get(PropertyRoutes.getProperty + `?search=${search}&id=${id}&page=${page}&limit=${limit}&start_price=${minPrice}&end_price=${maxPrice}&type=${type}&purpose=${purpose}&min_area=${minArea}&max_area=${maxArea}&dateFrom=${dateFrom}&dateTo=${dateTo}&isAdminPanel=${isAdminPanel}`);
    return result;
  },
  getPropertyAnalytics: async (search,id,page,limit,timeFilter,fromDate,toDate) => {
    let result = get(PropertyRoutes.getPropertyAnalytics + `?search=${search}&id=${id}&page=${page}&limit=${limit}&timeFilter=${timeFilter}&fromDate=${fromDate}&toDate=${toDate}`);
    return result;
  },
  getPropertyById: async (id) => {
    let result = get(PropertyRoutes.getPropertyById + `/${id}`);
    return result;
  },
  deleteProperty: async (id ) => {
    let result = deleted(PropertyRoutes.deleteProperty + `/${id}`);
    return result;
  },
  updateProperty: async (obj ) => {
    let result = patch(PropertyRoutes.updateProperty ,obj);
    return result;
  },
  getInvestrorProperty: async (search,page,limit,id) => {
    let result = get(PropertyRoutes.getInvestrorProperty + `?search=${search}&page=${page}&limit=${limit}&id=${id}`);
    return result;
  },
   markPropertyAsSold: async (propertyId, soldType, soldBy) => {
    let result = post(PropertyRoutes.markPropertyAsSold, { propertyId, soldType, soldBy });
    return result;
  },
    getClosedDeals: async (search,id,page,limit) => {
    let result = get(PropertyRoutes.getClosedDeals + `?search=${search}&id=${id}&page=${page}&limit=${limit}`);
    return result;
  }
};

export default PropertyServices;
